import {
	GetUserProfileResponse,
} from '@kemu-io/kemu-types';
import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import gatesManager from '@kemu-io/kemu-core/widgetsManager';
import * as userApi from '../../../api/user/userApi';
import { processUserWidgetsAction } from '../widget/processWidgetsReducer';
import { AsyncRequestStatus } from '../../../types/core_t';
import { updateRecipeCacheMeta } from '../../recipe/utils';
import { RootState } from '../../store';
// import khConnectionManager from '../../kemuHub/connectionManager';
import { CustomerState, setUserProfile } from './userSlice';

// let lastPromise: Promise<GetUserProfileResponse> | null = null;
/**
 * Loads the last user profile from the local storage
 * and performs a request to the server to get the latest
 * user profile and updates the local storage with it.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// const getOptimisticProfile = (dispatch: any): Promise<GetUserProfileResponse> => {
// 	// Return the last promise if it exists, which means that the profile is already being loaded
// 	if (lastPromise) {
// 		return lastPromise;
// 	}

// 	lastPromise = new Promise((resolve, reject) => {
// 		let alreadyResolved = false;

// 		userApi.getProfile().then((latestProfile) => {
// 			localStorage.setItem('user-profile', JSON.stringify(latestProfile));
// 			if (!alreadyResolved) {
// 				resolve(latestProfile);
// 			} else {
// 				// update user state
// 				dispatch(setUserProfile({
// 					user: latestProfile.user,
// 					organization: latestProfile.organization
// 				}));

// 				// update user widgets list
// 				dispatch(processUserWidgetsAction({ widgets: latestProfile.widgets }));
// 			}

// 			lastPromise = null;
// 		}).catch((error) => {
// 			console.error('Failed to get user profile', error);
// 			if (!alreadyResolved) {
// 				reject(error);
// 			}

// 			lastPromise = null;
// 		});

// 		const previousProfile = localStorage.getItem('user-profile');
// 		const parsed = safeJsonParse<GetUserProfileResponse>(previousProfile);
// 		if (parsed) {
// 			resolve(parsed);
// 			alreadyResolved = true;
// 		}
// 	});

// 	return lastPromise;
// };

/**
 * Fetches Kemu's user profile for the current user
 */
export const fetchUserProfileAction = createAsyncThunk('/user/fetch/profile', async (_, thunkAPI): Promise<GetUserProfileResponse> => {
	// Update title based on current language
	const loadWidgetsPromise = gatesManager.loadWidgets();
	const loadProfilePromise = userApi.getProfile();
	// const loadProfilePromise = getOptimisticProfile(thunkAPI.dispatch);

	const [profile] = await Promise.all([loadProfilePromise, loadWidgetsPromise]);
	const { user, widgets } = profile;

	// localStorage.setItem('user-profile', JSON.stringify(profile));

	// const isAdmin = user.organization?.role === 'Admin';
	// const isOwner = user.organization?.role === 'Owner';

	// Process the user's custom widgets and download any missing one
	await thunkAPI.dispatch(processUserWidgetsAction({ widgets }));

	await thunkAPI.dispatch(setUserProfile({
		user,
		organization: {
			...profile.organization,
		},
	}));

	// Update the current recipe information now that we have info about the author
	const { workspace } = thunkAPI.getState() as RootState;
	if (workspace.currentRecipe.poolId) {
		updateRecipeCacheMeta({
			recipePoolId: workspace.currentRecipe.poolId,
			meta: {
				authorId: user.id,
			},
		});
	}

	// Initially connect to KemuHub if an API key is available
	// if (profile.apiKey) {
	// 	khConnectionManager.start({
	// 		apiKey: profile.apiKey,
	// 		id: user.id,
	// 		email: user.email || '',
	// 	});
	// }

	return {
		...profile,
	};
});

export const fetchUserProfileReducer = ((builder: ActionReducerMapBuilder<CustomerState>): void => {

	builder.addCase(fetchUserProfileAction.pending, (state) => {
		state.currentUserProfile.asyncState.status = AsyncRequestStatus.loading;
	});

	builder.addCase(fetchUserProfileAction.rejected, (state, action) => {
		state.currentUserProfile.asyncState.status = AsyncRequestStatus.error;
		state.currentUserProfile.asyncState.error = action.error;
	});

	builder.addCase(fetchUserProfileAction.fulfilled, (state, action) => {
		state.currentUserProfile.asyncState.status = AsyncRequestStatus.completed;
		// state.currentUserProfile.accountState = action.payload.accountState;
		state.currentUserProfile.profile = action.payload.user;
		state.currentUserProfile.tokens = action.payload.tokens;
		state.currentUserProfile.integrations = action.payload.integrations;
	});
});
